"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.docCreator = void 0;
var firestore_1 = require("firebase/firestore");
var utils_1 = require("../utils");
// tested with update
var docCreator = function (fStore, collectionPath) {
    return function (firestore, documentId) {
        var fs = (0, utils_1.isFirestore)(firestore) ? firestore : fStore;
        var docId = (0, utils_1.isFirestore)(firestore) ? documentId : firestore;
        return (0, firestore_1.doc)(
        // @ts-expect-error
        fs, // ! type messed up, after adding firestore of testing type, weird
        collectionPath + '/' + docId);
    };
};
exports.docCreator = docCreator;
